import {
  PayrollLegalEntityFragment,
  SettingsPayrollConceptFragment,
} from 'generated/resources/graphql'
import { capitalize } from 'lodash'

import type { LegalEntities as LegalEntityCollection } from 'modules/core/store/collections/legalEntities'

import { DEFAULT_RESULT_CONCEPT } from 'modules/payroll_bundle/lib/constants'

export interface SettingsPayrollConceptWithLegalEntity
  extends Omit<SettingsPayrollConceptFragment, 'id'> {
  id: string
  name: string
  legalEntityName: string
  legalEntityId: number
}

type LegalEntities = LegalEntityCollection | PayrollLegalEntityFragment[]

export const buildPayrollConceptsByLegalEntitySettings = (
  concepts: SettingsPayrollConceptFragment[],
  legalEntities: LegalEntities
): SettingsPayrollConceptWithLegalEntity[] => {
  const conceptsExcludingSalary = concepts?.filter(
    (concept) => concept.name !== DEFAULT_RESULT_CONCEPT.base_salary
  )
  return legalEntities
    .map((legalEntity) =>
      conceptsExcludingSalary.map((concept) => {
        if (!legalEntity.id || !legalEntity.name) return null
        return {
          ...concept,
          id: `payroll_concept_code_${legalEntity.id}_${concept.id}`,
          name: concept.label,
          legalEntityName: capitalize(legalEntity.name),
          legalEntityId: legalEntity.id,
        }
      })
    )
    .flat()
    .filter((concept) => concept !== null)
}
